import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=558d4e2f&"
import script from "./manage.ts?vue&type=script&lang=ts&"
export * from "./manage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports